
"use client";

import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { Sparkles } from 'lucide-react';

const developerName = "Ganesh S P";

export function AppFooter() {
  const { loading, isEffectivelyPremium } = useAuth();

  // Show button if not loading and user is not effectively premium (includes guests)
  const shouldShowRemoveAdsButton = !loading && !isEffectivelyPremium;

  return (
    <footer className="w-full border-t bg-muted/30 dark:bg-muted/10 mt-auto">
      <div className="container mx-auto py-8 px-4 md:px-6 text-center space-y-6">
        {shouldShowRemoveAdsButton && (
          <div className="mb-6">
            <Button 
              asChild 
              variant="outline" 
              size="lg"
              className="border-primary text-primary hover:bg-primary/10 hover:text-primary shadow-lg transition-all hover:shadow-primary/40 transform hover:scale-105 active:scale-95"
            >
              <Link href="/pricing">
                <Sparkles className="mr-2 h-5 w-5" /> Remove Ads & Go Pro
              </Link>
            </Button>
            <p className="text-xs text-muted-foreground mt-3">
              Enjoy an ad-free experience and unlock all premium features by upgrading your plan.
            </p>
          </div>
        )}
        <div className="flex flex-col sm:flex-row items-center justify-between text-xs text-muted-foreground">
          <p className="mb-2 sm:mb-0">&copy; {new Date().getFullYear()} IntervuAI by {developerName}. All rights reserved.</p>
          <nav className="flex flex-wrap gap-4 sm:gap-6 justify-center">
            <Link href="/terms-of-service" className="hover:text-primary hover:underline underline-offset-4 transition-colors">
              Terms of Service
            </Link>
            <Link href="/privacy-policy" className="hover:text-primary hover:underline underline-offset-4 transition-colors">
              Privacy Policy
            </Link>
            <Link href="/about" className="hover:text-primary hover:underline underline-offset-4 transition-colors">
              About
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
